export default __webpack_public_path__ + "static/media/crc-block-pp-color.b807141f.svg";